import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import React from "react";
import { useNavigate } from 'react-router-dom'
import { userList, userSearch, sendsmsToCustomer } from '../../features/dashboard/UserSlice';
import Loading from '../../Loading';
import Header from './Header';
import Broadcast from './Broadcast';
import Button from '../../component/form/Button';
import { Calendar } from "react-multi-date-picker";
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import DataTable, { ExpanderComponentProps } from 'react-data-table-component';
import axios from 'axios';
import { host } from '../../function/api'
import * as Icon from 'react-feather';
import $ from 'jquery'
import * as moment from 'jalali-moment';
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'


function UserIndex() {

    const columns = [
        {
            name: '#',
            sortable: true,
            cell: (row, index) => <div className='rahpardaznet-border'>{index + 1} </div>,

        },
        {

            name: 'نام نمایشگاه',
            sortable: true,
            cell: row => <div className='rahpardaznet-border'>{row.name}</div>
        },
        {

            name: 'شهر',
            sortable: true,
            cell: row => <div className='rahpardaznet-border'>{row.city}</div>
        },
        {
            name: 'موبایل',
            sortable: true,
            cell: row => row.mobile == "" ? (<div className='rahpardaznet-border'><span>ثبت نشده</span></div>) : (<div className='rahpardaznet-border'><span>{row.mobile}</span></div>),
        },
        {
            name: 'وضعیت',
            sortable: true,
            cell: row => row.status == "1" ? (<div className='rahpardaznet-border'><span className='text-success'>فعال</span></div>) : (<div className='rahpardaznet-border'><span className='text-danger'>غیرفعال</span></div>)
        },
        {
            name: 'تاریخ ایجاد',
            sortable: true,
            cell: row => <div className="rahpardaznet-border">{moment(row.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</div>
        },
        {
            name: 'عملیات',
            cell: row => <div className='rahpardaznet-table-btn'>
               
               <span className='p-0'>
                    <button
                        className='rahpardaznet-icon-table'
                        data-tooltip-id={"tooltip-edit-"+row.id}
                        data-tooltip-content="ویرایش نمایشگاه"
                        data-tooltip-place="top"
                        onClick={(e) => editUser(row.id)}>
                        <i className="fa-solid fa-user"></i>
                    </button>
                    <Tooltip id={"tooltip-edit-"+row.id} style={{ backgroundColor: "#767676", color: "#fff" }} />
                </span>    

                <span className='p-0'>
                    <button
                        className='rahpardaznet-icon-table'
                        data-tooltip-id={"tooltip-archive-"+row.id}
                        data-tooltip-content="سطح دسترسی انبار"
                        data-tooltip-place="top"
                        onClick={(e) => archivepermissionStore(row.id)}>
                        <i className="fa-solid fa-box-archive"></i>
                    </button>
                    <Tooltip id={"tooltip-archive-"+row.id} style={{ backgroundColor: "#767676", color: "#fff" }} />
                </span>
                </div>
        },


    ];
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const token = localStorage.getItem('token')
    const [type, setType] = useState()
    const [value, setValue] = useState()
    const date = new DateObject({ calendar: persian, locale: persian_fa })
    const [usersList, setUsers] = useState({});
    const [page, setPage] = useState(1);
    const countPerPage = 5;

    const {
        users,
        loading,
        message,
        success,
        errorType,
        errorValue
    } = useSelector(state => state.user)


    const archivepermissionStore = (userId) => {
        navigate(`/dashboard/archive/permission/${userId}`)
    }
  
    const exhibitionRequest = (userId) => {
        navigate(`/dashboard/exhibition/requests/${userId}`)
    }
   
    const editUser = (userId) => {
        navigate(`/dashboard/exhibition/edit/${userId}`)
    }
    const userSearchHandler = (e) => {
        e.preventDefault()
        const data = {
            'type': type,
            'value': value
        }
        dispatch(userSearch(data));
    }
    const handlesms = (e) => {
        e.preventDefault()
        dispatch(sendsmsToCustomer())
    }
    const getExhibitionList = async (search = pinCode, pageNumber = page) => {
        $('.dlUCce').addClass('loading');

        try {
            const response = await axios({
                method: 'GET',
                url: `${host}exhibitions?page=${pageNumber}&per_page=${countPerPage}&search=${search}&delay=1`,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            // var usersList = JSON.stringify(response.data);
            setUsers(response.data.data);
            console.log(usersList);

            console.log(usersList);
            $('.dlUCce').removeClass('loading');

        } catch (error) {
            setUsers({});
            $('.dlUCce').removeClass('loading');
        }
    };
    function searchByDataTable(event) {
        let delayTimeOutFunction;
        delayTimeOutFunction = setTimeout(() => {
            getExhibitionList(event.target.value);


        }, 3000); // denounce delay

        return () => clearTimeout(delayTimeOutFunction);

    };
    const [pinCode, setPinCode] = useState("");
    useEffect(() => {
        getExhibitionList()
    }, []);
    const rahkarpardaznet_search_datatable = (e) => {
        e.preventDefault();
        setPage(1);
        getExhibitionList(pinCode);
    }
    const handlePageChange = (page) => {
        setPage(page);
        getExhibitionList(pinCode, page);
    };

    useEffect(() => {
        // console.log(Object.keys(users).length)
        // dispatch(userList(token))
    }, [])



    return (
        <>
            {loading ? (<Loading />) : ''}
            <Broadcast title={'مدیریت نمایشگاه ها'} />
          
                <div className='row g-2 pr-3 pl-3 pb-4'>

                    <div className="App">
                        <form onSubmit={rahkarpardaznet_search_datatable} className="rk-search-bar">
                            <input type="text" id="" placeholder='جستجو کنید' onChange={(event) => setPinCode(event.target.value)} />
                            <button type="submit" ><Icon.Search /></button>

                        </form>
                        <DataTable
                            title=""
                            columns={columns}
                            data={usersList.data}
                            className='rahpardaznet-table-user'
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={usersList.total}
                            paginationPerPage={countPerPage}
                            paginationComponentOptions={{
                                noRowsPerPage: true
                            }}
                            onChangePage={handlePageChange}
                        />
                    </div>


                </div>
         
        </>
    )
}

export default UserIndex;